"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var FalconCacheManager_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FalconCacheManager = void 0;
const AppMemoryStorage_1 = require("./AppMemoryStorage");
const rxjs_1 = require("rxjs");
const CryptoJS = __importStar(require("crypto-js"));
const operators_1 = require("rxjs/operators");
const core_1 = require("@athena-portal/core");
let FalconCacheManager = FalconCacheManager_1 = class FalconCacheManager {
    constructor(applicationGuard) {
        this.applicationGuard = applicationGuard;
        this.appMemoryStorage = new AppMemoryStorage_1.AppMemoryStorage();
    }
    clearCache(key, storage) {
        const storageToUse = this.getStorageToUse(storage);
        Object.entries(storageToUse).forEach(([k, v]) => {
            if (k.indexOf(key) !== -1) {
                storageToUse.removeItem(k);
            }
        });
        Object.entries(this.appMemoryStorage).forEach(([k, v]) => {
            if (k.indexOf(key) !== -1) {
                this.appMemoryStorage.removeItem(k);
            }
        });
    }
    clearAll(storage) {
        const storageToUse = this.getStorageToUse(storage);
        Object.entries(storageToUse).forEach(([k, v]) => {
            if (k.indexOf(FalconCacheManager_1.CACHE_PREFIX) !== -1) {
                storageToUse.removeItem(k);
            }
        });
        Object.entries(this.appMemoryStorage).forEach(([k, v]) => {
            if (k.indexOf(FalconCacheManager_1.CACHE_PREFIX_MEM) !== -1) {
                this.appMemoryStorage.removeItem(k);
            }
        });
    }
    saveObservable(key, data, useEncryption, storage, timeToLiveSec) {
        data.subscribe(value => {
            this.storeItemInMemory(key, value, timeToLiveSec);
            if (useEncryption) {
                this.getSecretPassphrase().subscribe(passphrase => {
                    const toSave = CryptoJS.AES.encrypt(JSON.stringify(value), passphrase).toString();
                    this.storeItem(key, toSave, true, this.getStorageToUse(storage), timeToLiveSec);
                });
            }
            else {
                this.storeItem(key, value, false, this.getStorageToUse(storage), timeToLiveSec);
            }
        });
    }
    tryGetObservable(key, storage) {
        const result = this.getItemFromMemory(key) || this.getItemFromCache(key, storage);
        if (result == null) {
            return null;
        }
        // Check if expired
        if (Date.now() > result.expires) {
            this.clearCache(key, storage);
            return null;
        }
        // Check owner
        if (result.encrypted && !result.owner && this.getOwner() !== result.owner) {
            this.clearCache(key, storage);
            return null;
        }
        if (result.encrypted) {
            return this.getSecretPassphrase()
                .pipe((0, operators_1.map)(passphrase => {
                try {
                    const bytes = CryptoJS.AES.decrypt(result.data, passphrase);
                    const originalText = bytes.toString(CryptoJS.enc.Utf8);
                    const item = JSON.parse(originalText);
                    this.storeItemInMemory(key, item, result.expires / 1000);
                    return item;
                }
                catch (e) {
                    this.clearCache(key, storage);
                    return (0, rxjs_1.of)(null);
                }
            }));
        }
        else {
            return (0, rxjs_1.of)(result.data);
        }
    }
    getSecretPassphrase() {
        if (!this.applicationGuard) {
            throw new Error("Unable to encrypt cahe value. IApplicationGuard is not bind to container");
        }
        return this.applicationGuard
            .fetchToken() // Token itself is not used, however this ensures application guard has done authentication and user data population
            .pipe((0, operators_1.map)((token) => {
            return this.applicationGuard.getUser().id;
        }));
    }
    isCached(key, storage) {
        return this.appMemoryStorage.getItem(FalconCacheManager_1.CACHE_PREFIX_MEM + key) != null ||
            this.getStorageToUse(storage).getItem(FalconCacheManager_1.CACHE_PREFIX + key) != null;
    }
    storeItem(key, value, encrypted, storage, timeToLiveSec) {
        const ttlToUse = timeToLiveSec || FalconCacheManager_1.DEFAULT_TIME_TO_LIVE;
        storage.setItem(FalconCacheManager_1.CACHE_PREFIX + key, JSON.stringify({
            data: value,
            encrypted,
            expires: Date.now() + (ttlToUse * 1000),
            owner: encrypted ? this.getOwner() : undefined
        }));
    }
    storeItemInMemory(key, value, timeToLiveSec) {
        const ttlToUse = timeToLiveSec || FalconCacheManager_1.DEFAULT_TIME_TO_LIVE;
        this.appMemoryStorage.setItem(FalconCacheManager_1.CACHE_PREFIX_MEM + key, JSON.stringify({
            data: value,
            encrypted: false,
            expires: Date.now() + (ttlToUse * 1000)
        }));
    }
    getItemFromCache(key, storage) {
        const item = this.getStorageToUse(storage).getItem(FalconCacheManager_1.CACHE_PREFIX + key);
        if (item) {
            return JSON.parse(item);
        }
        else {
            return null;
        }
    }
    getItemFromMemory(key) {
        const item = this.appMemoryStorage.getItem(FalconCacheManager_1.CACHE_PREFIX_MEM + key);
        if (item) {
            return JSON.parse(item);
        }
        else {
            return null;
        }
    }
    getOwner() {
        var _a;
        if (this.applicationGuard.isAuthenticated() && this.applicationGuard.getUser() != null) {
            return (_a = this.applicationGuard.getUser()) === null || _a === void 0 ? void 0 : _a.name;
        }
        return;
    }
    getStorageToUse(storage) {
        if (storage) {
            return storage;
        }
        // Fallback to memory storage if session storage not supported
        if (window.sessionStorage) {
            return window.sessionStorage;
        }
        return this.appMemoryStorage;
    }
};
exports.FalconCacheManager = FalconCacheManager;
FalconCacheManager.DEFAULT_TIME_TO_LIVE = 300;
FalconCacheManager.CACHE_PREFIX = "FalconCache_";
FalconCacheManager.CACHE_PREFIX_MEM = "FalconCacheMem_";
exports.FalconCacheManager = FalconCacheManager = FalconCacheManager_1 = __decorate([
    (0, core_1.injectable)(),
    __param(0, (0, core_1.inject)(core_1.TypeDefs.ApplicationGuard)),
    __param(0, (0, core_1.optional)()),
    __metadata("design:paramtypes", [Object])
], FalconCacheManager);
//# sourceMappingURL=FalconCacheManager.js.map